import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

class LoyaltyPointsLevel extends React.Component {
  static propTypes = {
    level: PropTypes.object.isRequired,
    levelNumber: PropTypes.number.isRequired,
    selected: PropTypes.string,
    setSelectedLevel: PropTypes.func.isRequired,
    trailingText: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.selectLevel = this.selectLevel.bind(this);
    this.renderTrailing = this.renderTrailing.bind(this);
  }

  selectLevel () {
    this.props.setSelectedLevel(this.props.levelNumber);
  }

  renderTrailing () {
    if (this.props.trailingText) {
      return this.props.trailingText;
    }
  }

  render () {
    return (
      <div
        key={this.props.level.title}
        onClick={this.selectLevel}
        className={'loyalty-points-overview-level' + this.props.selected}
      >
        <div className='level-title-container'>
          <div className='level-icon'>
            <img src={this.props.level.icon} />
          </div>
          <div>
            <Translate className='level-title' content={this.props.level.title} />
            <p className='level-points'>{this.props.level.pointsLabel}</p>
          </div>
        </div>
        {this.renderTrailing()}
      </div>);
  }
}

export default LoyaltyPointsLevel;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/level.js
 **/